import { createSelector } from 'reselect';
import { NAME } from './constants';
import { selectors as coreSelectors } from '../core';

export const isFinishedTour = (state, type) => state[NAME][type].isFinished;

export const getIsFinishedProductTour = createSelector(coreSelectors.getShowTourConfiguration, config => {
    return config === '0';
});
